import { ConcreteEncodable } from "./ConcreteEncodable";

import { WebTierFeedEventEncoder } from "../../encoder/WebTierFeedEventEncoder";

import * as CubiqTS from "../../index";

export class WebTierFeedEvent extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.service.WebTierFeedEvent";

  /*FID=1*/
  public rateEvent: CubiqTS.MarketDataEvent | null = null;
  /*FID=2*/
  public tslEvent: Array<CubiqTS.TrailingStopEvent> | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = WebTierFeedEventEncoder.Instance;
    this.setEncodableType(WebTierFeedEvent.enType);
    //Model
  }

  public toString(): string {
    return (
      "WebTierFeedEvent[" +
      "rateEvent=" +
      this.rateEvent +
      "tslEvent=" +
      this.tslEvent +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
